import useActivityAudio from '@monorepo/shared/src/hooks/use-activity-audio';
import { useEffect, useRef } from 'react';
import { formatSound } from '@monorepo/shared/src/util/sound-format-util';

const useAudioInstructions = (instructions, loaded) => {
  const [{ sounds, currentSound }, { playSoundFromState, loadAudioAssets, stopSound }] =
    useActivityAudio();
  const sound = sounds[instructions?.description ?? ''];
  const soundRef = useRef(currentSound);

  useEffect(() => {
    if (loaded && sound) {
      playSoundFromState(sound, true);
    }
  }, [loaded, sound?.sound._src]);

  useEffect(() => {
    if (instructions) {
      const instructionSound = formatSound(
        instructions.description as string,
        instructions.src,
        instructions.vtt as string
      );
      loadAudioAssets([instructionSound]);
    }
  }, [instructions]);

  useEffect(() => {
    soundRef.current = currentSound;
  }, [currentSound]);

  useEffect(() => {
    soundRef?.current?.stop();
    currentSound && stopSound();
    return () => {
      if (soundRef.current) {
        soundRef.current.stop();
        currentSound && stopSound();
      }
    };
  }, []);
};

export default useAudioInstructions;
